export default __webpack_public_path__ + "static/media/view.6233dc6d.svg";